import styled from 'styled-components';

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 600px;
  position: relative;
  gap: 10px;
`;

const ModalForm = styled.form`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(880px, calc(100vw - 30px));
  max-height: 80vh;
  overflow-y: auto;
  background-color: #fff;
  padding: 25px;
  border-radius: 20px 25px;
`;

const FeatureButton = styled.button`
  border: 0;
  padding: 0;
  background: transparent;
  font: inherit;
  color: ${(p) => p.theme.colors.primary300};
  text-decoration: underline;
  cursor: pointer;
`

const IconWrapper = styled.span`
  position: absolute;
  right: 15px;
  top: 5px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;

const LinkWrapper = styled.div`
  width: min(425px, 100%);
  padding: 13px 10px;
  border: 1px solid ${(p) => p.theme.colors.gray300};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  h4{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${(p) => p.theme.colors.primary500};
  }
`;

export {
  SearchBar,
  ModalForm,
  FeatureButton,
  IconWrapper,
  LinkWrapper
};
